var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Stack, Typography } from "@mui/material";
import { useOrderInfoSection } from "../hooks/useOrderInfoSection";
import { OpenBalanceTexts } from "../utils/openBalance-enums";
export const OrderInfoSection = () => {
    const _a = useOrderInfoSection(), { isMobile, textSX } = _a, OIS = __rest(_a, ["isMobile", "textSX"]);
    return (_jsxs(Stack, Object.assign({ sx: {
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? 1 : 2,
            alignItems: isMobile ? "flex-start" : "center",
            justifyContent: isMobile ? "flex-start" : "space-between",
        } }, { children: [_jsx(Typography, Object.assign({ sx: textSX }, { children: `${OpenBalanceTexts.ORDER_NUMBER}: ${OIS.orderNumber}` })), _jsx(Typography, Object.assign({ sx: textSX }, { children: `${OpenBalanceTexts.ORDER_ID}: ${OIS.orderId}` })), _jsx(Typography, Object.assign({ sx: textSX }, { children: `${OpenBalanceTexts.REMAINING_BALANCE}: ${OIS.remainingBalanceDisplay}` })), !!OIS.showInvoiceButton && (_jsx(Button, Object.assign({ fullWidth: isMobile, size: "medium", variant: "outlined", color: "primary", onClick: () => OIS.setOpenInvoice((prev) => !prev) }, { children: OpenBalanceTexts.VIEW_INVOICE })))] })));
};
